import React from 'react';
import FormControlWrapper from './FormControlWrapper';
import InputForm from './InputForm';
import DropDown from './DropDown';
import RadioButtons from './RadioButtons';
import Checkbox from './Checkbox';
// import DatePicker from './DatePicker';
// import Textarea from './Textarea';
// import DocumentUpload from './DocumentUpload';
// import PhoneNumber from './PhoneNumber';
// import CheckboxList from './CheckboxList';
// import Chips from './Chips';
// import Tiles from './Tiles';
// import Switch from './Switch';
import Slider from './Slider';
// import AddressLookup from './AddressLookup';
import { InputTypes } from '../types/InputTypes';
// import RepeatableBlock from './RepeatableBlock'; // eslint-disable-line import/no-cycle

const getFormControl = (formName: string, controlName: string, type: InputTypes): JSX.Element => {
    switch (type) {
        case 'checkbox':
            return <Checkbox formName={formName} controlName={controlName} />;

        case 'dropdown':
            return <DropDown formName={formName} controlName={controlName} />;

        case 'radio':
            return <RadioButtons formName={formName} controlName={controlName} />;

        case 'text':
            return <InputForm formName={formName} controlName={controlName} />;

        case 'tel':
            return <InputForm formName={formName} controlName={controlName} />;

        case 'email':
            return <InputForm formName={formName} controlName={controlName} />;

        case 'number':
            return <InputForm formName={formName} controlName={controlName} />;

        // case 'datePicker':
        //     return <DatePicker formName={formName} controlName={controlName} />;

        case 'hidden':
            return <InputForm formName={formName} controlName={controlName} />;

        case 'inputWithOptions':
            return <InputForm formName={formName} controlName={controlName} />;

        // case 'documentUpload':
        //     return <DocumentUpload formName={formName} controlName={controlName} />;

        // case 'repeatableBlock':
        //     return <RepeatableBlock formName={formName} controlName={controlName} />;

        // case 'textarea':
        //     return <Textarea formName={formName} controlName={controlName} />;

        // case 'checkboxList':
        //     return <CheckboxList formName={formName} controlName={controlName} />;

        // case 'phoneNumber':
        //     return <PhoneNumber formName={formName} controlName={controlName} />;

        // case 'chips':
        //     return <Chips formName={formName} controlName={controlName} />;

        // case 'tiles':
        //     return <Tiles formName={formName} controlName={controlName} />;

        // case 'switch':
        //     return <Switch formName={formName} controlName={controlName} />;

        case 'slider':
            return <Slider formName={formName} controlName={controlName} />;

        // case 'addressLookup':
        //     return <AddressLookup formName={formName} controlName={controlName} />;

        default:
            return <InputForm formName={formName} controlName={controlName} />;
    }
};

function FormControlFactory({
    controlName,
    formName,
    type,
}: {
    controlName: string;
    type: InputTypes;
    formName: string;
}) {
    // prevent wrapping for repeatableBlock
    // if (type === 'repeatableBlock') {
    //     return <RepeatableBlock formName={formName} controlName={controlName} />;
    // }

    const Fn = getFormControl(formName, controlName, type);

    return (
        <FormControlWrapper formName={formName} controlName={controlName}>
            {Fn}
        </FormControlWrapper>
    );
}

export default FormControlFactory;
